import React from "react";
import { useHistory } from "react-router-dom";
import images from "../../../../../../utilities/images/images";
import "./Header.css";

const Header = () => {
  const history = useHistory();
  return (
    <div className="ncert-header">
      <img
        src={images.backBtn}
        alt="back-btn"
        onClick={() => history.push("/dashboard")}
        style={{ cursor: "pointer" }}
      />
      <div className="ncert-header-text">NCERT Practice</div>
    </div>
  );
};

export default Header;
